/*
 * The sign-in page (src/v3/pages/dmz/SignInView.vue) - the wave-1 pilot.
 * Owned by wave 1 and FROZEN during wave 2.
 */
export default {
  signin_document_title: { en: 'Sign In - ReadyChek', fr: 'Connexion - ReadyChek', es: 'Iniciar sesión - ReadyChek' },
  labelLogin: { en: 'Sign In', fr: 'Connexion', es: 'Iniciar sesión' },
  sign_in_welcome: { en: 'Welcome', fr: 'Bienvenue', es: 'Bienvenido' },
  signin_subtitle: { en: 'To continue with ReadyChek', fr: 'Pour continuer avec ReadyChek', es: 'Para continuar con ReadyChek' },
  labelPassword: { en: 'Password', fr: 'Mot de passe', es: 'Contraseña' },
  sign_in_lost_password: { en: 'Forgot your password?', fr: 'Mot de passe oublié?', es: '¿Olvidó su contraseña?' },
  employee_select_sign_in_button: { en: 'Sign In', fr: 'Se connecter', es: 'Iniciar sesión' },
  signin_new_account_prompt: {
    en: "New? If you don't have an account yet:",
    fr: "Nouveau? Si vous n'avez pas encore de compte :",
    es: '¿Es nuevo? Si aún no tiene una cuenta:',
  },
  signin_create_account: { en: 'Create an Account', fr: 'Créer un compte', es: 'Crear una cuenta' },
  signin_right_for_me: { en: 'Is ReadyChek right for me?', fr: 'ReadyChek me convient-il?', es: '¿ReadyChek es adecuado para mí?' },
  signin_right_for_me_title: { en: 'Is ReadyChek Right For Me?', fr: 'ReadyChek me convient-il?', es: '¿ReadyChek es adecuado para mí?' },
  signin_return_to_site: { en: 'Return to ReadyChek.com', fr: 'Retour à ReadyChek.com', es: 'Volver a ReadyChek.com' },
  signin_right_for_me_circle: {
    en: 'If you stay within the circle, you can use the ReadyChek solution. Chat with us for more details or sign up today!',
    fr: "Si vous restez à l'intérieur du cercle, vous pouvez utiliser la solution ReadyChek. Clavardez avec nous pour en savoir plus ou inscrivez-vous dès aujourd'hui!",
    es: 'Si permanece dentro del círculo, puede usar la solución ReadyChek. Chatee con nosotros para obtener más detalles o regístrese hoy mismo.',
  },
  signin_chat_with_us: { en: 'Chat with Us', fr: 'Clavarder avec nous', es: 'Chatee con nosotros' },
  signin_free_trial: { en: 'Free 30-Day Trial', fr: 'Essai gratuit de 30 jours', es: 'Prueba gratuita de 30 días' },

  // Progress
  status_connecting: { en: 'Connecting...', fr: 'Connexion...', es: 'Conectando...' },
  sign_in_signing_in: { en: 'Signing in...', fr: 'Connexion en cours...', es: 'Iniciando sesión...' },
  signin_searching_account: { en: 'Searching for your account', fr: 'Recherche de votre compte', es: 'Buscando su cuenta' },
  signin_searching_company: { en: 'Searching for your company', fr: 'Recherche de votre entreprise', es: 'Buscando su empresa' },
  signin_searching: { en: 'Searching please wait...', fr: 'Recherche en cours, veuillez patienter...', es: 'Buscando, espere...' },

  // Errors (UserEvents.SignIn.Errors, matched by messageId)
  signin_unreachable: {
    en: 'It appears that ReadyChek.cloud is not reachable at the moment.',
    fr: 'ReadyChek.cloud semble inaccessible pour le moment.',
    es: 'Parece que ReadyChek.cloud no está disponible en este momento.',
  },
  signin_error_not_found: {
    en: 'The specified username and password combination do not exist',
    fr: "Cette combinaison de nom d'utilisateur et de mot de passe n'existe pas",
    es: 'Esa combinación de usuario y contraseña no existe',
  },
  signin_error_unauthorized: {
    en: 'You do not have permission to access the portal',
    fr: "Vous n'avez pas la permission d'accéder au portail",
    es: 'No tiene permiso para acceder al portal',
  },

  // Seasonal event card (shown in late December and early January)
  signin_ad_where: {
    en: 'Come visit us at the Toronto Congress Centre (Booth E7)',
    fr: 'Venez nous voir au Toronto Congress Centre (kiosque E7)',
    es: 'Visítenos en el Toronto Congress Centre (stand E7)',
  },
  signin_ad_details: {
    en: "We'll be in the education section at booth E7 with Tri-Shield.ca Consulting. If you'd like free tickets, please contact us.",
    fr: 'Nous serons dans la section éducation, au kiosque E7, avec Tri-Shield.ca Consulting. Si vous souhaitez des billets gratuits, communiquez avec nous.',
    es: 'Estaremos en la sección educativa, en el stand E7, con Tri-Shield.ca Consulting. Si desea entradas gratuitas, contáctenos.',
  },
  signin_ad_dates: { en: 'Jan 6, 7 and 8', fr: '6, 7 et 8 janvier', es: '6, 7 y 8 de enero' },
};
